import api from './index.ts'
import config from '@/config'

export async function syncAuth() {
  await api.post(`${config.backendUrl}/api/users/sync`)
}

export async function searchUsers(query: string) {
  return await api.get(`${config.backendUrl}/api/users/search`, { query: query, limit: 5 })
}
